import {
    RESET_VERIFY_LOGIN_EMAIL_OTP,
    VERIFY_LOGIN_EMAIL_OTP_SUCCESS,
    VERIFY_LOGIN_EMAIL_OTP_REQUEST
} from '../actions'

const initialState = {
    isVerified: true,
    contactNoVerified: null
}

export default function(state = initialState, action) {
    switch (action.type) {
        case RESET_VERIFY_LOGIN_EMAIL_OTP :
            return Object.assign({}, state, { isVerified : true });
        case VERIFY_LOGIN_EMAIL_OTP_REQUEST:
            return Object.assign({}, state, {isVerified: false});
        case VERIFY_LOGIN_EMAIL_OTP_SUCCESS:
            return Object.assign({}, state, { isVerified : true }, { contactNoVerified: action.payload.data.contactNoVerified });
        default:
            return state;
    }
}